import { cva } from 'class-variance-authority';
export const spinnerVariants = cva('inline animate-spin fill-transparent', {
    variants: {
        variant: {
            base: '',
            invert: 'text-white',
        },
        size: {
            small: 'h-4 w-4',
            large: 'h-10 w-10',
            medium: 'h-7 w-7',
        },
    },
    defaultVariants: {
        variant: 'base',
        size: 'small',
    },
});
//# sourceMappingURL=variants.js.map